import { IGNORED_INSURANCES } from '../constants/insurance-section';

function inIgnoredInsurances(insurance?: string): boolean {
  return IGNORED_INSURANCES.includes(insurance);
}

export default inIgnoredInsurances;
